import * as React from 'react';
import {connect} from 'react-redux';
import {withStyles, WithStyles, Dialog, DialogActions, DialogTitle, IconButton, Popover, TextField} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {calendarStyle} from './calendar.style';
import MonthView from '@components/calendar2/monthView/MonthView';
import { weeksMonth } from '@components/calendar2/helper';
import WeekView from '@components/calendar2/dayDetails/WeekView';
import CreateEvent from '@components/calendar2/eventdetails/CreateEvent';
import SplitPane from '@components/calendar2/splitpane/Splitpane';
import Header from '@components/calendar2/header/Header';
import * as UserActions from '@services/user/user.actions';
import EditFooter from '@components/calendar2/editPane/EditFooter';
import { ILocalCalendarEvent, ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import { IAppToken, ICalendarSetting } from '@app-types/websocket/user.types';
import { IDateRange } from './calendar.helpter';
import { addDays, getWeekStart, toIsoDate } from '@helpers/DateHelper';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import { generateSuggestions } from '@helpers/calendar/suggestionCalculator';
import { ICreateSuggestion, ISuggestion, IRespondSuggestion } from '@app-types/websocket/suggestion.types';
import * as Suggestion from '@services/suggestion/suggestion.action';
import { applySuggestion } from '@helpers/calendar/scheduleCalculator';
import Button from '@components/common/button/Button';
import { CustomDialogContent, DialogTop, Row } from '@components/economy/DialogComponens';
import CloseIcon from "@material-ui/icons/Close";
import * as ChatActions from '@services/chat/chat.actions';
import { ChatType, ICreateChat, ICreateChatMessage, IChat } from '@app-types/websocket/chat.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';
import { SUGGESTION_TYPES } from '@constants/suggestionTypes';
import { IEvent, ILocalEvent } from '@app-types/websocket/event.types';
import CalendarFAB from '@components/calendar2/fab/CalendarFAB';
import * as EventActions from '@services/events/event.action';
import { IScheduleEvent } from '@components/calendar2/dayDetails/scheuldeEvent.types';
import DayPopUpMenu from '@components/calendar2/monthView/DayPopUpMenu';
import EditScheduleEvent from '@components/calendar2/eventdetails/EditScheduleEvent';
import AddScheduleSleep from '@components/calendar2/eventdetails/AddScheduleSleep';
import { addQuickSleep, shiftSpecificDay, swapParent } from '@components/calendar2/editPane/editActions/QuickChange/QuickChangeCalc';
import { createArrayCopyAndSort, ensureScheduleConsistency } from '@components/calendar2/editPane/editActions/ScheduleCalc';
import AiCreateEvents from '@components/calendar2/eventdetails/AiCreateEvents';
import EditEventDialog from '@components/calendar2/eventdetails/EditEventDialog';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';
import PinchZoomImage from '@helpers/PinchZoomImage';
import { app } from 'firebase';
import { EditPaneOption } from '@components/calendar2/editPane/EditPane.types';
import { getSelectedFamilyResource } from '@services/user/user.utils';
import { runCordovaPluginCall } from '@helpers/cordovaBridge';
import { memoizeLast } from '@helpers/memoizeLast';

const tn: TranslateNew = TranslateNew.getInstance();
const AI_SCHEDULE_FEEDBACK_PREFIX:string = "AI did not get calendar changes right.";

declare const window: any;

interface IProps extends RouteComponentProps, WithStyles<typeof calendarStyle> {
  userId:number;
  showWeekNumber:boolean;

  scheduleOne:ISchedule|undefined;
  scheduleTwo:ISchedule|undefined;
  scheduleThree:ISchedule|undefined;

  allSchedules:ISchedule[];
  suggestions:ISuggestion[];
  family:IFamilyMember[];
  events:IEvent[];
  chats:IChat[];

  externalEventsPerDay:{ [day: string]: IExternalCalenderEvent []}

  calendarSettings: ICalendarSetting;
  localization:"se"|"en";
  online:boolean;
  appSettings:{calendarHeight:number, calendarSize:"small"|"medium"|"large"};
  updateAppSettings:(settings:{calendarHeight:number, calendarSize:"small"|"medium"|"large"}) => void
  createSuggestion: (data: ICreateSuggestion) => void;
  respondSuggestion: (data:IRespondSuggestion) => void;
  createChat: (data: ICreateChat) => void;
  sendChatMessage:(message:ICreateChatMessage) => void;
  displayErrorMessage:(message:string) => void;
  seenEvent: (id:number) => void;
  updateToken: (token: IAppToken) => void;
  storeToken: (token: string) => void;

  isTogether:boolean;
}

interface IState {
  // monthHeight:number;
  currentYear:number; // to display in header
  currentMonth:number; // to display in header
  selectedDay:Date; // the day marked in the calendar
  initialDayInDayPane:Date; // the day clicked in calendar
  monthSize: "small"|"medium"|"large";  // week view, split, big calendar
  isResizing:boolean; // if isLongPress re-sizing stuff;
  showEventDetails:number|undefined; // show edit part of events in week view
  showEscheduleEventDetails:IScheduleEvent|undefined;
  editingScheduleId:number, // 0 = no editing, > 0 = id of schedule we edit
  suggestionId:number,
  selectedEditDays:IDateRange[]; // array of startOfDay -> endOf day timestamps of selected days
  highlight:IDateRange[]; // array of startOfDay -> endOf day timestamps of days to highlight
  scheduleEditBase:ISchedule|undefined; // a local copy while editing;
  scheduleEditPreview:ISchedule|undefined; // a local copy while showing edit;
  scheduleEditHistory:ISchedule[]; // to be able to go back in edits
  scheduleEditHistoryPopped:ISchedule[]; // to be able to go forward in edits
  editMsg:string;
  errorMessage:string;
  errorSuggestion:number;
  editOption:EditPaneOption;
  localEvents:ILocalEvent[];
  waitForLoad:IExtractedIds;
  unseenEvents:IEvent[];

  popMenuRef:HTMLDivElement|null;

  createEventOnDate:Date|undefined;

  quickEditHandoverPosition:"START"|"END"|"DAYVISIT";
  quickEditHandover:IScheduleEvent|null;
  quickEditSleepsAtParent:number|null;
  quickEditSleepsAtScheduleId:number|null;
  quickEditScheduleId:number|null;
  quickEditEventId:number|null;

  showCreateAIEventsDialog:boolean;

  zoomImage:string|undefined;
  zoomImageUrl:string|undefined;
  rateApp:boolean;

  deviceReady:boolean;
  showPromptForAllDays:number; // -1 = no prompt, -2 = do not prompt again otherwise the time of the first day
  aiSchedulePrompted:boolean;
  aiScheduleUndoFingerprint:string|undefined;
  showAiScheduleFeedbackDialog:boolean;
  aiScheduleFeedback:string;
  aiScheduleFeedbackContext:"cancel"|"undo"|undefined;
}

interface IRouteParams {
  calendarId?: string;
  suggestionId?: string;
}

// one shared empty map, so the calendar does not see new external events on every store update
const NO_EXTERNAL_EVENTS:{ [day: string]: IExternalCalenderEvent []} = {};

class CalendarContainer extends React.Component<IProps, IState> {
  private paneStart: number = 0; // where click started
  private monthHeight:number = 0; // height of calendar window
  private monthViewRef:React.RefObject<HTMLDivElement> = React.createRef();
  private paneRef:React.RefObject<HTMLDivElement> = React.createRef();
  private prevLoc:string|undefined;
  private lastLocalLoad:number = 0;
  // the same array while nothing changed, so the month view can skip laying out its events again
  private filterLocalEvents = memoizeLast((localEvents:ILocalEvent[], synchCalendar:boolean|undefined,
    excludeCalendar:string[]|undefined, startDate:number, endDate:number) => localEvents.filter((event) => synchCalendar === true
      && (excludeCalendar === undefined || !excludeCalendar.includes(event.calendar))
      && (event.endTime > startDate && event.startTime < endDate)));
  private localCalendarReady:boolean = false;

  constructor(props: IProps) {
    super(props);

    const monthSize = props.appSettings.calendarSize;
    const currentDate:Date = new Date();
    const thisMonth = {year:currentDate.getFullYear(), month:currentDate.getMonth(), 
      weeksInMonth: weeksMonth(currentDate.getMonth(),currentDate.getFullYear(), this.props.localization)};

    this.prevLoc = props.history.location.pathname;
    this.paneStart = 0,
    this.monthHeight = ((monthSize === "medium")
      ?((thisMonth.weeksInMonth*40)+10)
      :(monthSize === "small") 
        ?50
        :(props.appSettings.calendarHeight?props.appSettings.calendarHeight:(window.innerHeight-140)));
    
    if (window.innerHeight - this.monthHeight < 180 ) {
      if (monthSize === "large") {
        this.monthHeight = window.innerHeight-140;
      } else {
        this.monthHeight = window.innerHeight-170;
      }
      
    }

    this.state = {
      currentMonth:currentDate.getMonth(),
      currentYear:currentDate.getFullYear(),
      selectedDay:currentDate,
      suggestionId:0,
      initialDayInDayPane:currentDate,
      monthSize,
      isResizing:false,
      showEventDetails:undefined,
      showEscheduleEventDetails:undefined,
      editingScheduleId:0,
      selectedEditDays:[],
      highlight:[],
      scheduleEditBase:undefined,
      scheduleEditPreview:undefined,
      scheduleEditHistory:[],
      scheduleEditHistoryPopped:[],
      editMsg:"",
      errorMessage:"",
      editOption:"quickedit",
      errorSuggestion:0,
      localEvents:[],
      waitForLoad:{eventId:null, scheduleId:null, suggestionId:null},
      unseenEvents:[],
      popMenuRef:null,

      createEventOnDate:undefined,

      showCreateAIEventsDialog:false,
      
      quickEditHandoverPosition:"END",
      quickEditHandover:null,
      quickEditSleepsAtParent:null,
      quickEditSleepsAtScheduleId:null,
      quickEditScheduleId:null,
      quickEditEventId:null,

      zoomImage:undefined,
      zoomImageUrl:undefined,

      rateApp:false,
      deviceReady:false,
      showPromptForAllDays:-1,
      aiSchedulePrompted:false,
      aiScheduleUndoFingerprint:undefined,
      showAiScheduleFeedbackDialog:false,
      aiScheduleFeedback:"",
      aiScheduleFeedbackContext:undefined,
    };
    
  }


  public componentDidUpdate(prevProps:IProps, prevState:IState) {

    if (this.props.calendarSettings !== prevProps.calendarSettings && (this.state.deviceReady || this.localCalendarReady)) {
      this.loadLocalEvents();
    }

    if (this.state.waitForLoad.scheduleId !== null || this.state.waitForLoad.eventId !== null) {
      const givenIds = this.state.waitForLoad;
      if (givenIds.scheduleId !== null && givenIds.suggestionId !== null) {

        if (this.props.allSchedules && this.props.allSchedules.length > 0
          && (
            (this.props.suggestions && this.props.suggestions.length > 0 && this.props.suggestions.find((sug) => sug.id === givenIds.suggestionId))
            || givenIds.suggestionId === 0)
          && this.props.allSchedules.find((sche) => sche.id === givenIds.scheduleId)) {

            this.setState({waitForLoad:{scheduleId:null,suggestionId:null, eventId:null}});

            const schId = givenIds.scheduleId;
            const sugId = givenIds.suggestionId;
  
            const scheduleToEdit:ISchedule|undefined = this.props.allSchedules.find((schedule) => schedule.id === schId);
      
            if (scheduleToEdit !== undefined) {
              
              const suggestion = this.props.suggestions.find((sug) => sug.id === sugId);
              let base:ISchedule = JSON.parse(JSON.stringify(scheduleToEdit));
    
              if (suggestion) {
                // this.toggleEditMode(scheduleToEdit.id, suggestion.id);      
                const suggestedSchedule:{schedule:ISchedule, success:boolean} = applySuggestion(scheduleToEdit, suggestion);
                if (suggestedSchedule.success) {
                  base = suggestedSchedule.schedule;
                } else {
                  this.setState({errorMessage:tn.lang.calErrorApplySuggestion, errorSuggestion:suggestion.id,
                    waitForLoad:{scheduleId:null,suggestionId:null, eventId:null}});
                  // this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
                  return;
                }    
              } 
              const preview:ISchedule = JSON.parse(JSON.stringify(base));
              this.setNewEditMode(scheduleToEdit.id, sugId, base, preview);
            }
          }
      } else if (givenIds.eventId !== null) {
        if (this.props.events && this.props.events.length > 0) {
          const event = this.props.events.find((ev) => ev.id === givenIds.eventId);
          if (event !== undefined) {
            const gotoDate = new Date(event.startTime);
            this.setState((prev) => ({...prev,initialDayInDayPane:gotoDate, selectedDay:gotoDate
              ,waitForLoad:{scheduleId:null,suggestionId:null, eventId:null}}));
          }
        }
      }
    } else if (this.state.editingScheduleId === 0 
      && this.props.history.location 
      && this.props.history.location.pathname !== this.prevLoc) {
      this.prevLoc = this.props.history.location.pathname;
      let givenIds:IExtractedIds =  extractIdsFromString(this.props.match.params);
      
      if (givenIds.scheduleId !== null && givenIds.suggestionId !== null ) {
        if (this.props.suggestions && this.props.suggestions.length > 0 && this.props.allSchedules && this.props.allSchedules.length > 0
          && (this.props.suggestions.find((sug) => sug.id === givenIds.suggestionId) || givenIds.suggestionId === 0) 
          && this.props.allSchedules.find((sche) => sche.id === givenIds.scheduleId)) {
          const schId = givenIds.scheduleId;
          const sugId = givenIds.suggestionId;

          const scheduleToEdit:ISchedule|undefined = this.props.allSchedules.find((schedule) => schedule.id === schId);
    
          if (scheduleToEdit !== undefined) {
            
            const suggestion = this.props.suggestions.find((sug) => sug.id === sugId);
            let base:ISchedule = JSON.parse(JSON.stringify(scheduleToEdit));
  
            if (suggestion) {
              // this.toggleEditMode(scheduleToEdit.id, suggestion.id);      
              const suggestedSchedule:{schedule:ISchedule, success:boolean} = applySuggestion(scheduleToEdit, suggestion);
              if (suggestedSchedule.success) {
                base = suggestedSchedule.schedule;
              } else {
                this.setState((prev) => ({...prev,errorMessage:tn.lang.calErrorApplySuggestion, errorSuggestion:suggestion.id}));
                // this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
                return;
              }    
            } 
            const preview:ISchedule = JSON.parse(JSON.stringify(base));

            givenIds = {scheduleId:null, suggestionId:null, eventId:null};
            this.setNewEditMode(scheduleToEdit.id, sugId, base,preview);

          } else {
            alert("could not find schedule: "+schId);
          }
        } else {
          this.setState((prev) => ({...prev,waitForLoad:givenIds}));
        }
      } else if (givenIds.eventId !== null ) {
        if (this.props.events && this.props.events.length > 0) {
          const event = this.props.events.find((ev) => ev.id === givenIds.eventId);
          if (event !== undefined) {
            const initialDayInDayPane = new Date(event.startTime);
            givenIds = {scheduleId:null, suggestionId:null, eventId:null};
            this.setState({waitForLoad:{scheduleId:null, suggestionId:null, eventId:null}});
            this.setSelectedDay(initialDayInDayPane.getFullYear(),initialDayInDayPane.getMonth(),initialDayInDayPane.getDate(), 
              "SELECT", "NAN", false);
          }
        }
      }
      
    }

    if (this.state.suggestionId > 0 && prevProps.suggestions !== this.props.suggestions && this.state.errorMessage === "") {
      const suggestion = this.props.suggestions.find((sugg) => sugg.id === this.state.suggestionId);
      if (suggestion) {
        if (suggestion.status === SUGGESTION_TYPES.ACCEPTED_AND_EXECUTED) {
          this.setState((prev) => ({...prev,errorMessage:tn.lang.calSuggestionAccepted}));
          this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
        } else if (suggestion.status === SUGGESTION_TYPES.DELETED) {
          this.setState((prev) => ({...prev,errorMessage:tn.lang.calSuggestionDeleted}));
          this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
        } else if  (suggestion.status === SUGGESTION_TYPES.REJECTED) {
          this.setState((prev) => ({...prev,errorMessage:tn.lang.calSuggestionRejected}));
          this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
        }
      }
    }
    if (this.props.events !== prevProps.events) {
      this.setState((prev) => ({...prev,unseenEvents:this.props.events.filter((event) => (event.seen && !event.seen.includes(this.props.userId)))}))
    }
  }

  public componentDidMount(): void {

    this.setMonthSize(this.state.monthSize)

    document.addEventListener("deviceready", this.handleDeviceReady, false);
    document.addEventListener("resume", this.handleLocalCalendarResume, false);
    document.addEventListener("visibilitychange", this.handleLocalCalendarVisibilityChange, false);
    if (window.plugins && window.plugins.calendar) {
      this.handleDeviceReady();
    }

    let errorMessage = "";
    let errorSuggestion = 0;
    let givenIds:IExtractedIds = {eventId:null, scheduleId:null, suggestionId:null};
    let suggestionId = 0;
    let initialDayInDayPane:Date = this.state.initialDayInDayPane;
    let monthSize = this.state.monthSize;
    let inEditMode = 0;
    let scheduleEditBase:ISchedule | undefined;
    let scheduleEditPreview:ISchedule | undefined;

    const unseenEvents = this.props.events.filter((event) => (event.seen && !event.seen.includes(this.props.userId)));


    if (this.props.match && this.props.match.params) {
      givenIds = extractIdsFromString(this.props.match.params);
      
      if (givenIds.scheduleId !== null && givenIds.suggestionId !== null && givenIds.suggestionId !== 0) {
        if (this.props.suggestions && this.props.suggestions.length > 0 && this.props.allSchedules && this.props.allSchedules.length > 0
          && this.props.suggestions.find((sug) => sug.id === givenIds.suggestionId) 
          && this.props.allSchedules.find((sche) => sche.id === givenIds.scheduleId)) {
          const schId = givenIds.scheduleId;
          const sugId = givenIds.suggestionId;

          const scheduleToEdit:ISchedule|undefined = this.props.allSchedules.find((schedule) => schedule.id === schId);
    
          if (scheduleToEdit !== undefined) {
            
            const suggestion = this.props.suggestions.find((sug) => sug.id === sugId);
    
            if (suggestion && suggestion.status !== SUGGESTION_TYPES.AWAITING_APPROVAL) {
              errorMessage = tn.lang.calErrorSuggestionNotFound;
            } else if (suggestion) {
              const suggestedSchedule:{schedule:ISchedule, success:boolean} = applySuggestion(scheduleToEdit, suggestion);
              if (suggestedSchedule.success) {
                monthSize = "large";
                inEditMode = schId;
                suggestionId = sugId;
                this.monthHeight = window.innerHeight-315;
                scheduleEditBase = ensureScheduleConsistency(suggestedSchedule.schedule);
                scheduleEditPreview = JSON.parse(JSON.stringify(scheduleEditBase));
              } else {
                errorMessage = tn.lang.calErrorApplySuggestion;
                errorSuggestion = suggestion.id;
                return;
              }

              givenIds = {scheduleId:null, suggestionId:null, eventId:null};
            }
          }
        }
      } else if (givenIds.eventId !== null ) {
        if (this.props.events && this.props.events.length > 0) {
          const event = this.props.events.find((ev) => ev.id === givenIds.eventId);
          if (event !== undefined) {
            initialDayInDayPane = new Date(event.startTime);
            givenIds = {scheduleId:null, suggestionId:null, eventId:null};
            this.setState({waitForLoad:{scheduleId:null, suggestionId:null, eventId:null}});
            this.setSelectedDay(initialDayInDayPane.getFullYear(),initialDayInDayPane.getMonth(),initialDayInDayPane.getDate(), 
              "SELECT", "NAN", false);
          }
        }
      }
    }

    this.setCalendarHeight(this.monthHeight);


    this.setState({
      errorMessage,
      errorSuggestion,
      waitForLoad:givenIds,
      initialDayInDayPane,
      suggestionId,
      editingScheduleId: inEditMode,
      scheduleEditBase,
      scheduleEditPreview,
      unseenEvents,
      monthSize,
    });



  }

  public componentWillUnmount(): void {
    document.removeEventListener("deviceready", this.handleDeviceReady, false);
    document.removeEventListener("resume", this.handleLocalCalendarResume, false);
    document.removeEventListener("visibilitychange", this.handleLocalCalendarVisibilityChange, false);
  }

  public render() {
    const {classes, calendarSettings} = this.props;
    const scheduleCurrentEdit:ISchedule|undefined = this.props.allSchedules.find((sched) => sched.id === this.state.editingScheduleId);

    const scheduleOne:ISchedule|undefined = ((this.state.editingScheduleId === 0)?this.props.scheduleOne:this.state.scheduleEditPreview);
    const scheduleTwo:ISchedule|undefined = ((this.state.editingScheduleId === 0)?this.props.scheduleTwo:scheduleCurrentEdit);
    const scheduleThree:ISchedule|undefined = ((this.state.editingScheduleId === 0)?this.props.scheduleThree:undefined);
  
    const now:Date = new Date();
    const schoolAge:number = schoolAgeFromFamily(this.props.family);


    const clickAction:"SELECT"|"SELECT_FOR_EDIT"|"QUICK_EDIT" = (this.state.editingScheduleId !== 0)
      ? "SELECT_FOR_EDIT"
      : "SELECT";

    const inView = new Date(this.state.currentYear, this.state.currentMonth, 1);
    const startDate = inView.getTime() - 1000*60*60*24*62;
    const endDate = inView.getTime() + 1000*60*60*24*62;

    const filteredLocalEvents = this.filterLocalEvents(this.state.localEvents, calendarSettings.synchCalendar,
      calendarSettings.excludeCalendar, startDate, endDate);

    return (
        <div className={classes.container}>
          <Header 
            showWeekNumber={this.props.showWeekNumber}
            selectRange={(from:number,to:number, days:boolean[]) => this.selectDays(from,to, days)}
            localization={this.props.localization} 
            currentMonth={this.state.currentMonth}
            currentYear={this.state.currentYear}
            isEditing={(this.state.editingScheduleId !== 0)}
            suggestionId={this.state.suggestionId}
            setMonthSize={(size:"small"|"medium"|"large") => {this.setMonthSize(size); 
              setTimeout(() => this.setSelectedDay(now.getFullYear(), now.getMonth(), now.getDate(), "SELECT", "NAN", false), 500)
              }}
            monthSize={(this.state.monthSize === "large" && this.monthHeight < window.innerHeight-140)?"medium":this.state.monthSize}
            selectedDays={this.state.selectedEditDays}
            setSelectedDate={(year:number,month:number,date:number) => this.setSelectedDay(year,month,date,"SELECT","NAN", false)}
            makeNewSuggestionGuide={(scheduleId:number) => this.setState((prev) => ({...prev,quickEditScheduleId:scheduleId}))}
            startEditing={(scheduleId:number, suggestionId:number) => this.toggleEditMode(scheduleId, suggestionId)}
            cancelEditing={() => this.requestCancelEdit()}
            isTogether={this.props.isTogether}
          />
          <MonthView // the month display
            reference={this.monthViewRef}
            scheduleOne={scheduleOne}
            scheduleTwo={scheduleTwo}
            schoolAge={schoolAge}
            scheduleThree={scheduleThree}
            inEditMode={(this.state.editingScheduleId > 0)}
            localization={this.props.localization} 
            focusDay={this.state.selectedDay}
            fetchedEvents={this.props.externalEventsPerDay}
            localEvents={filteredLocalEvents}
            selectedEditDays={this.state.selectedEditDays}
            highlight={this.state.highlight}
            isResizing={this.state.isResizing}
            monthSize={this.state.monthSize}
            setHeight={(height:number) => this.setCalendarHeight(height)}
            showWeekNumber={this.props.showWeekNumber}
            selectIDayInsteadOfMenuPop={this.state.editOption === "timePlace" || this.state.editOption === "dayvisit"  }
            popMenu={(ref:HTMLDivElement) => { this.popMenu(ref) }}
            swipeEdit={(year:number,month:number,date:number, swipeDays:number, swipdeStartSide:"LEFT"|"RIGHT") => 
              this.swipeEdit(year,month,date,swipeDays,swipdeStartSide)}
            swipeEditTransaction={(action:"START"|"COMMIT") => this.swipeEditTransaction(action)}
            setFocusDate={(year:number,month:number,date:number, position:"LEFT"|"RIGHT"|"NAN", isLongPress:boolean, originalDay?:Date, swipeType?:"PARENT_A"|"PARENT_B"|"NAN"|"HANDOVER"|"VISITATION") => 
              this.setSelectedDay(year,month,date,clickAction, position, isLongPress, originalDay)}
            setCurrentMonth={(year:number, month:number) => this.setCurrentMonth(year,month)}
          />

          <SplitPane 
            paneRef={this.paneRef}
            moveStart={(screenY:number) => this.moveStart(screenY)}
            moveMove={(screenY:number) => this.moveMove(screenY)}
            moveEnd={() => this.moveEnd()}
            inEditMode={(this.state.editingScheduleId > 0)}
          >
            <WeekView  // the views of the day - list
              // paneRef={this.paneRef}
              zoomImage={(url) => this.setState((prev) => ({...prev,zoomImage:url, zoomImageUrl:url}))}
              localization={this.props.localization} 
              schoolAge={schoolAge}
              isResizing={this.state.isResizing}
              initialDay={this.state.initialDayInDayPane}
              showEventDetails={this.state.showEventDetails}
              localEvents={filteredLocalEvents}
              externalEventsPerDay={this.props.externalEventsPerDay}
              showEditHandover={this.state.showEscheduleEventDetails}
              setShowEditHandover={(event) => this.setState((prev) => ({...prev,showEscheduleEventDetails:event}))}
              createEventOnDate={(day:Date) => this.setState((prev) => ({...prev,createEventOnDate:day}))}
              setShowEventDetails={(eventId:number|undefined) => this.setState((prev) => ({...prev,showEventDetails:eventId}))}
              setSelectedDay={(selectedDay:Date) => {this.setState((prev) => ({...prev,selectedDay})); 
                this.scrollToMonth(selectedDay.getFullYear(), selectedDay.getMonth());}} 
            />
          </SplitPane>



          <EditFooter
            setFocusDate={(year:number,month:number,date:number) => this.setSelectedDay(year,month,date,"SELECT", "NAN", false)}
            inEditMode={(this.state.editingScheduleId > 0)}
            selectedDays={this.state.selectedEditDays}
            clearSelection={() => this.clearSelectedDays()}
            scheduleCurrent={scheduleCurrentEdit}
            scheduleEditBase={this.state.scheduleEditBase}
            scheduleEditPreview={this.state.scheduleEditPreview}
            updatePreview={(schedule:ISchedule) => this.setState((prev) => ({...prev,scheduleEditPreview:schedule}))}
            onAiSchedulePrompted={() => this.setState({aiSchedulePrompted:true})}
            onAiScheduleApplied={(schedule:ISchedule) => this.setState({aiScheduleUndoFingerprint:JSON.stringify(schedule)})}
            updateBase={(schedule:ISchedule) => this.setState((prev) =>  
              ({...prev,scheduleEditBase:schedule, scheduleEditHistoryPopped:[],
                scheduleEditHistory:this.buildHistory(prev.scheduleEditHistory, (prev.scheduleEditBase?prev.scheduleEditBase:undefined))}))}
            setCalendarHighlight={(range:IDateRange[]) => this.setState((prev) => ({...prev,highlight:range}))}
            msg={this.state.editMsg}
            updateMsg={(msg:string, sendDirectly:boolean) => this.updateMsg(msg,sendDirectly)}
            sendSuggestion={() => this.sendSuggestion(scheduleCurrentEdit)}
            option={this.state.editOption}
            localization={this.props.localization}
            setEditOption={(option) => this.setState((prev) => ({...prev,editOption:option, showPromptForAllDays:-1}))}
            suggestionId={this.state.suggestionId}
            acceptSuggestion={(id) => this.acceptSuggestion(id)}
            declineSuggestion={(id) => this.declineSuggestion(id)}
            deleteSuggestion={(id) => this.declineSuggestion(id)}
            cancelEdit={() => this.requestCancelEdit()}
            selectRange={(from:number,to:number, days:boolean[]) => this.selectDays(from,to, days)}
            undoAvailable={this.state.scheduleEditHistory.length > 0}
            redoAvailable={this.state.scheduleEditHistoryPopped.length > 0}
            historyStep={(step:"back"|"forward") => this.requestHistoryStep(step)}
          />

          <CalendarFAB // the Floating Action Buttons in bottom right corner
            currentSchedules={(calendarSettings && calendarSettings.calendars)?calendarSettings.calendars:[]}
            currentYear={this.state.currentYear}
            currentMonth={this.state.currentMonth}
            inEditMode={(this.state.editingScheduleId>0 || this.state.showEventDetails !== undefined 
              || this.state.showEscheduleEventDetails !== undefined)}
            selectedDay={this.state.selectedDay}
            initialDay={this.state.initialDayInDayPane}
            createEventOnDate={() => this.setState((prev) => ({...prev,createEventOnDate:this.state.selectedDay}))}
            createAiEvents={() => this.setState((prev) => ({...prev,showCreateAIEventsDialog:true}))}
            size={this.state.monthSize}
            makeNewSuggestion={(scheduleId:number) => this.toggleEditMode(scheduleId,0)}
            setSelectedDay={(year: number, month: number, date: number) => this.setSelectedDay(year,month,date,"SELECT", "NAN", true)}
            scrollToMonth={(year: number, month: number, smooth?: boolean) => this.scrollToMonth(year,month,smooth)}
          />

          <Dialog
            open={this.state.showAiScheduleFeedbackDialog}
            onClose={() => this.closeAiScheduleFeedbackDialog()}
            fullWidth={true}
            maxWidth="sm">
            <DialogTop>
              <DialogTitle>{tn.lang.scheduleAiFeedbackTitle}</DialogTitle>
              <IconButton onClick={() => this.closeAiScheduleFeedbackDialog()}>
                <CloseIcon />
              </IconButton>
            </DialogTop>
            <div style={{padding:'0px 24px 16px'}}>{tn.lang.scheduleAiFeedbackText}</div>
            <div style={{padding:'0px 24px 8px'}}>
              <TextField
                autoFocus={true}
                fullWidth={true}
                multiline={true}
                minRows={4}
                maxRows={4}
                variant="outlined"
                value={this.state.aiScheduleFeedback}
                placeholder={tn.lang.scheduleAiFeedbackPlaceholder}
                inputProps={{maxLength:5000}}
                onChange={(event) => this.setState({aiScheduleFeedback:event.target.value})}
              />
            </div>
            <DialogActions style={{padding:'8px 24px 24px'}}>
              <Button
                variant="outlined"
                classes={{outlined:classes.buttonOutlined}}
                onClick={() => this.closeAiScheduleFeedbackDialog()}>
                {tn.lang.noThanks}
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!this.props.online || this.state.aiScheduleFeedback.trim().length === 0}
                onClick={() => this.sendAiScheduleFeedback()}>
                {tn.lang.send}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={(this.state.zoomImage !== undefined)}
            onClose={() => {this.setState((prev) => ({...prev,zoomImage:undefined}));}}
            fullWidth={true}
          >
            <DialogTop >
              <div style={{flex:1, alignItems: 'center'}} />
              <IconButton onClick={() => {this.setState((prev) => ({...prev,zoomImage:undefined}));}}>
                <CloseIcon />
              </IconButton>
            </DialogTop>
            <CustomDialogContent style={{position:'relative', padding:0}}>
              <PinchZoomImage src={this.state.zoomImageUrl || ""}  style={{height: "auto"}}/> 
            {/*  <img src={this.state.zoomImageUrl} style={{height:'auto'}}/> */}
            </CustomDialogContent>
            <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
              <Button onClick={() => {this.setState((prev) => ({...prev,zoomImage:undefined}));}} color='default' variant='contained' size="large">
                {tn.lang.done}
              </Button>
            </Row>
          </Dialog>
          <Dialog // dialog for select multiple days
            open={(this.state.editOption === "timePlace" || this.state.editOption === "dayvisit") 
              && this.state.showPromptForAllDays > 0 && (this.state.editingScheduleId !== 0)}
            onClose={() => {this.setState((prev) => ({...prev,showPromptForAllDays:-1}));}}
            fullWidth={true}
          >
            <DialogTop >
              <div style={{flex:1, alignItems: 'center'}} />
              <IconButton onClick={() => {this.setState((prev) => ({...prev,showPromptForAllDays:-1}));}}>
                <CloseIcon />
              </IconButton>
            </DialogTop>
            <CustomDialogContent style={{position:'relative', padding:0, alignItems:'center', textAlign:'center'}}>
              {this.state.editOption === "dayvisit"
                ?tn.lang.calSelectEveryOther(tn.lang.getWeekdayName((new Date(this.state.showPromptForAllDays)).getDay()))
                :tn.lang.calSelectAll(tn.lang.getWeekdayName((new Date(this.state.showPromptForAllDays)).getDay()))}
            </CustomDialogContent>
            <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
              <Button onClick={() => {this.setState((prev) => ({...prev,showPromptForAllDays:-2}));}} 
                variant='outlined' classes={{ outlined: classes.buttonOutlined }}>
                {tn.lang.no}
              </Button>
              <Button onClick={() => {this.selectAllDaysOfWeek(this.state.showPromptForAllDays, this.state.editOption === "dayvisit"?2:1); 
                this.setState((prev) => ({...prev,showPromptForAllDays:-1})); }} 
                color='primary' variant='outlined' classes={{ outlined: classes.buttonOutlined }}>
                {tn.lang.yes}
              </Button>
            </Row>
          </Dialog>
          <Dialog // error message display
            open={this.state.errorMessage !== ""}
            onClose={() => {this.setState((prev) => ({...prev,errorMessage:"", errorSuggestion:0})); 
              if (this.state.suggestionId > 0) {this.toggleEditMode(0,0);}}}
          >
            <DialogTop>
              <DialogTitle>{tn.lang.calInfo}</DialogTitle>
              <IconButton onClick={() => {this.setState((prev) => ({...prev,errorMessage:"", errorSuggestion:0})); 
                if (this.state.suggestionId > 0) {this.toggleEditMode(0,0);}}}>
                <CloseIcon />
              </IconButton>
            </DialogTop>
            <div style={{padding: '8px 24px', display: 'flex', flexDirection: 'column'}}>
              {this.state.errorMessage}
            </div>


            <div style={{display: "flex", flexDirection: "column",alignItems: "center", margin: "8px 24px", padding: "8px 24px", gap: "10px"}} >
              <Button variant='contained' color='secondary' style={this.state.errorSuggestion === 0?{display:'none'}:{}}
                onClick={() => {this.declineSuggestion(this.state.errorSuggestion); 
                  this.setState({errorMessage:"",errorSuggestion:0}); if (this.state.suggestionId > 0) {this.toggleEditMode(0,0);} }}>
                    <div style={{margin: "4px"}}>
                  {tn.lang.calErrorDeleteSuggestion}
                  </div>
              </Button>
              <Button variant='contained' style={{width: "fit-content"}}
                onClick={() => {this.setState({errorMessage:"",errorSuggestion:0}); if (this.state.suggestionId > 0) {this.toggleEditMode(0,0);}}}>
                 <div style={{margin: "4px"}} >
                  {tn.lang.close}
                  </div>
              </Button>
            </div>



          </Dialog>
          <Popover // popover on longpress
            disableScrollLock={true}
            anchorEl={this.state.popMenuRef}
            onClose={() => {this.setState({popMenuRef:null})}}
            open={this.state.popMenuRef !== null}
            classes={{paper:classes.popupPaper, root:classes.popupBackground}}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <DayPopUpMenu 
              open={this.state.popMenuRef !== null}
              localization={this.props.localization}
              zoomImage={(url) => this.setState({zoomImage:url, zoomImageUrl:url})}
              close={() => {this.setState({popMenuRef:null})}}
              selectedDay={this.state.initialDayInDayPane}
              importedEvents={filteredLocalEvents}
              externalEvents={this.props.externalEventsPerDay[toIsoDate(this.state.selectedDay)]}
              editEvent={(id) => this.setState({quickEditEventId:id})}
              createEvent={() => this.setState({createEventOnDate:this.state.selectedDay})}
              editSchedule={(scheduleId:number, suggestionId:number) => this.toggleEditMode(scheduleId, suggestionId)}
              editHandover={(position:"START"|"END", event:IScheduleEvent) => 
                this.setState({quickEditHandoverPosition:position, quickEditHandover:event})}
              sleepsAt={(scheduleId:number, parent:number) => 
                this.setState({quickEditSleepsAtParent:parent, quickEditSleepsAtScheduleId:scheduleId})}
            />
          </Popover>
          <EditEventDialog  // dialog for quick editing an event
            open={ this.state.quickEditEventId !== null}
            close={() => this.setState({quickEditEventId:null})}
            event={this.state.quickEditEventId !== null?this.props.events.find((e) => e.id === this.state.quickEditEventId):undefined}
          />
          <Dialog // dialog for quick editing a handover
            open={this.state.quickEditHandover !== null}
            onClose={() => this.setState({quickEditHandover:null})}
            classes={{paper:this.props.classes.bigDialog}}
          >
            <DialogTop>
              <div style={{flex:1}}/>
              <IconButton onClick={() => this.setState({quickEditHandover:null})}>
                <CloseIcon />
              </IconButton>
            </DialogTop>
            <div style={{position:'relative', overflow: 'hidden', display: 'flex'}}>
              {(this.state.quickEditHandover !== null) && 
                <EditScheduleEvent 
                  saveToOngoingSchedule={(this.state.editingScheduleId > 0 && this.state.editOption === "quickedit")
                    ?((s) => {this.storeNewScheduleEdit(s);})
                    :undefined}
                  event={this.state.quickEditHandover}
                  position={this.state.quickEditHandoverPosition}
                  close={() => this.setState({quickEditHandover:null})}/>}
            </div>
          </Dialog>
          <Dialog // Dialog for quick editing who has responsibility
            open={this.state.quickEditSleepsAtScheduleId !== null}
            onClose={() => this.setState({quickEditSleepsAtParent:null, quickEditSleepsAtScheduleId:null})}
            classes={{paper:this.props.classes.bigDialog}}
            >
              <DialogTop>
                <div style={{flex:1}}/>
                <IconButton onClick={() => this.setState({quickEditSleepsAtParent:null, quickEditSleepsAtScheduleId:null})}>
                  <CloseIcon />
                </IconButton>
              </DialogTop>
              <div style={{position:'relative', overflow: 'hidden', display: 'flex'}}>
                {(this.state.quickEditSleepsAtScheduleId !== null && this.state.quickEditSleepsAtParent !== null) && <AddScheduleSleep
                  initialDay={this.state.initialDayInDayPane}
                  parent={this.state.quickEditSleepsAtParent}
                  scheduleId={this.state.quickEditSleepsAtScheduleId}
                  close={() => this.setState({quickEditSleepsAtScheduleId:null, quickEditSleepsAtParent:null})}/>}
              </div>
          </Dialog>
          <CreateEvent // dialog for creating events
            close={() => this.setState({createEventOnDate:undefined})}
            open={this.state.createEventOnDate !== undefined}
            onDate={this.state.createEventOnDate}
          />
          <AiCreateEvents
            close={() => this.setState({showCreateAIEventsDialog:false})}
            open={this.state.showCreateAIEventsDialog === true}
            rateApp={() => setTimeout(() => {this.setState({rateApp:true})}, 3000)}
          />
        </div>
    );
  }

  private popMenu(ref:HTMLDivElement) {
    if (this.state.editingScheduleId === 0) {
      this.setState({popMenuRef:ref});
    } else if (this.state.editOption === "quickedit" && this.state.scheduleEditBase !== undefined) {
      if (ref.id !== undefined) {
        const dateSplit = ref.id.split("-");
        if (dateSplit.length === 3) {
          try {
            const pushDate = new Date(parseInt(dateSplit[0],10),parseInt(dateSplit[1],10),parseInt(dateSplit[2],10),);
            const startofDay = pushDate.getTime();
            const endOfEndDay =(addDays(pushDate,1)).getTime();

            let quickEditHandover:IScheduleEvent|null = null;
            let quickEditHandoverPosition:"START"|"END"|"DAYVISIT" = "START";
            const scheduleSide:IScheduleEntry[] = createArrayCopyAndSort(this.state.scheduleEditBase.data.scheduleEntriesParentA);
            for (const entry of scheduleSide) {
              if (entry.startTime > startofDay && entry.startTime < endOfEndDay || entry.endTime > startofDay && entry.endTime < endOfEndDay) {

                quickEditHandover = {
                  startAtSchool:entry.startAtSchool,
                  endAtSchool:entry.endAtSchool,
                  eventId:entry.id,
                  schedule:this.state.scheduleEditBase,
                  children:this.state.scheduleEditBase.data.children,
                  parent:this.state.scheduleEditBase.data.parentA,
                  startTime:entry.startTime,
                  endTime:entry.endTime,
                  startLoc:entry.startLoc,
                  endLoc:entry.endLoc,
                  parentColor:"#eee",
              
                  schedulePosition:1,
              
                  packingListStatus:"future",
                  packingList:[],
                  hideThis:false,
                };

                if ((entry.startTime >= startofDay && entry.startTime < endOfEndDay) 
                  && (entry.endTime >= startofDay && entry.endTime < endOfEndDay)) {
                  quickEditHandoverPosition = "DAYVISIT";
                } else if (entry.startTime >= startofDay && entry.startTime < endOfEndDay) {
                  quickEditHandoverPosition = "START";
                } else if (entry.endTime >= startofDay && entry.endTime < endOfEndDay) {
                  quickEditHandoverPosition = "END";
                }

              }
            }
            if (quickEditHandover === null || quickEditHandoverPosition === "START" || quickEditHandoverPosition === "END") {
              const scheduleSideB:IScheduleEntry[] = createArrayCopyAndSort(this.state.scheduleEditBase.data.scheduleEntriesParentB);
              for (const entry of scheduleSideB) {
                if (entry.startTime > startofDay && entry.startTime < endOfEndDay && entry.endTime > startofDay && entry.endTime < endOfEndDay) {

                  quickEditHandover = {
                    startAtSchool:entry.startAtSchool,
                    endAtSchool:entry.endAtSchool,
                    eventId:entry.id,
                    schedule:this.state.scheduleEditBase,
                    children:this.state.scheduleEditBase.data.children,
                    parent:this.state.scheduleEditBase.data.parentB,
                    startTime:entry.startTime,
                    endTime:entry.endTime,
                    startLoc:entry.startLoc,
                    endLoc:entry.endLoc,
                    parentColor:"#eee",
                
                    schedulePosition:1,
                
                    packingListStatus:"future",
                    packingList:[],
                    hideThis:false,
                  };

                  quickEditHandoverPosition = "DAYVISIT";

                }
              }
            }
            this.setState({quickEditHandover, quickEditHandoverPosition});
          } catch (e) {
            console.log(e);
          }
        }
      }
    }
  }

  private buildHistory(history:ISchedule[], schedule:ISchedule|undefined):ISchedule[] {

    if (schedule === undefined) {
      return history;
    }

    if (history.length === 0) {
      return [schedule];
    }
    
    if (history[history.length-1].id !== schedule.id) {
      return [schedule];
    }

    if (JSON.stringify(history[history.length-1]) === JSON.stringify(schedule)) {
      return history;
    }

    if (history.length > 10) {
      return history.slice(history.length-20).concat(schedule);
    }



    return history.concat(schedule);
  }

  private requestHistoryStep(step:"back"|"forward"):void {
    const isUndoingLatestAiChange = step === "back"
      && this.state.aiScheduleUndoFingerprint !== undefined
      && this.state.scheduleEditBase !== undefined
      && JSON.stringify(this.state.scheduleEditBase) === this.state.aiScheduleUndoFingerprint;

    this.historyStep(step);
    this.setState({
      aiScheduleUndoFingerprint:undefined,
      aiSchedulePrompted:isUndoingLatestAiChange ? false : this.state.aiSchedulePrompted,
      showAiScheduleFeedbackDialog:isUndoingLatestAiChange,
      aiScheduleFeedback:isUndoingLatestAiChange ? "" : this.state.aiScheduleFeedback,
      aiScheduleFeedbackContext:isUndoingLatestAiChange ? "undo" : this.state.aiScheduleFeedbackContext,
    });
  }

  private historyStep(step: "back" | "forward") {
    this.setState((prev) => {
      const { scheduleEditHistory, scheduleEditHistoryPopped, scheduleEditBase } = prev;

      if (step === "back" && scheduleEditHistory.length > 0) {
        // 1. Get the last item from history
        const previous = scheduleEditHistory[scheduleEditHistory.length - 1];
        
        // 2. New History is the old history minus the last item
        const newHistory = scheduleEditHistory.slice(0, -1);
        
        // 3. Push the CURRENT state onto the "Popped" (redo) stack
        const newPopped = scheduleEditBase 
          ? [...scheduleEditHistoryPopped, scheduleEditBase] 
          : scheduleEditHistoryPopped;

        return {
          ...prev,
          scheduleEditPreview: previous,
          scheduleEditBase: previous,
          scheduleEditHistory: newHistory,
          scheduleEditHistoryPopped: newPopped,
        };
      } 

      if (step === "forward" && scheduleEditHistoryPopped.length > 0) {
        // 1. Get the item to restore
        const futureVersion = scheduleEditHistoryPopped[scheduleEditHistoryPopped.length - 1];
        
        // 2. New Popped is the old popped minus the last item
        const newPopped = scheduleEditHistoryPopped.slice(0, -1);
        
        // 3. Push the CURRENT state back onto the History stack
        const newHistory = scheduleEditBase 
          ? [...scheduleEditHistory, scheduleEditBase] 
          : scheduleEditHistory;

        return {
          ...prev,
          scheduleEditPreview: futureVersion,
          scheduleEditBase: futureVersion,
          scheduleEditHistory: newHistory,
          scheduleEditHistoryPopped: newPopped,
        };
      }

      return prev; // No change if conditions aren't met
    });
  }

  private storeNewScheduleEdit(schedule:ISchedule) {
    this.setState((prev) => ({...prev, scheduleEditPreview:schedule, scheduleEditBase:schedule, scheduleEditHistoryPopped:[],
      scheduleEditHistory:this.buildHistory(prev.scheduleEditHistory,(prev.scheduleEditBase?prev.scheduleEditBase:undefined))}));
  }

  private setCalendarHeight(height:number) {
    if (this.monthViewRef.current) {
      if (this.props.appSettings.calendarSize === "large" && !(this.state.editingScheduleId > 0)) {
        this.monthViewRef.current.style.height = ("calc(100% - 140px)");
        this.monthViewRef.current.style.maxHeight = ("calc(100% - 140px)");
        this.monthViewRef.current.style.minHeight = ("calc(100% - 140px)");
      } else {
        this.monthViewRef.current.style.height = (height+"px");
        this.monthViewRef.current.style.maxHeight = (height+"px");
        this.monthViewRef.current.style.minHeight = (height+"px");
      }

      if (this.state.monthSize === "medium") {
        if (this.paneStart === 0) {
          this.monthViewRef.current.style.transition = "all 0.2s";
        } else {
          this.monthViewRef.current.style.transition = "";
        }
      } else {
        this.monthViewRef.current.style.transition = "";
      }
    }
    if (this.paneRef.current) {
      if (height === window.innerHeight-140) {
        this.paneRef.current.style.display = "none";
      } else {
        this.paneRef.current.style.display = "initial";
      }
      this.paneRef.current.style.height = ('calc(100% - '+(height+65)+"px)");
      this.paneRef.current.style.maxHeight = ('calc(100% - '+(height+65)+"px)");
      this.paneRef.current.style.minHeight = ('calc(100% - '+(height+65)+"px)");
      if (this.state.monthSize === "medium") {
        if (this.paneStart === 0) {
          this.paneRef.current.style.transition = "all 0.2s";
        } else {
          this.paneRef.current.style.transition = "";
        }
      } else {
        this.paneRef.current.style.transition = "";
      }
    }
  }

  private updateMsg(msg:string, sendDirectly:boolean) {
    this.setState({editMsg:msg});
  }

  private sendSuggestion(base:ISchedule|undefined) {
    const suggestion:ICreateSuggestion = generateSuggestions(base, this.state.scheduleEditBase);

    if (this.state.editMsg && this.state.editMsg.length > 0) {
      suggestion.msg = this.state.editMsg;
      let chatId:number|undefined;
      let scheduleId:number|undefined;
      if (base && base.id) {scheduleId = base.id}
      if (scheduleId) {
        for ( const chat of this.props.chats) {
          if (chat.chatType === ChatType.SCHEDULE_CHAT) {
            if (chat.referenceObject === scheduleId) {
              chatId = chat.id;
              break;
            }
          }
        }  
      }
      suggestion.chatId = chatId;
    }
    
    if (suggestion.changes.length > 0) {
      if (this.state.suggestionId > 0) {
        this.props.respondSuggestion({
          approve:false,
          suggestionId:this.state.suggestionId,
          isSilent: true
        })
        suggestion.isUpdate=true;
      }
    
      suggestion.track=true;
      this.props.createSuggestion(suggestion);
    }
    this.toggleEditMode(0, 0);
  }

  private requestCancelEdit():void {
    if (this.state.aiSchedulePrompted) {
      this.setState({
        showAiScheduleFeedbackDialog:true,
        aiScheduleFeedback:"",
        aiScheduleFeedbackContext:"cancel",
      });
      return;
    }

    this.toggleEditMode(0,0);
  }

  private closeAiScheduleFeedbackDialog():void {
    if (this.state.aiScheduleFeedbackContext === "cancel") {
      this.toggleEditMode(0,0);
      return;
    }

    this.setState({
      showAiScheduleFeedbackDialog:false,
      aiScheduleFeedback:"",
      aiScheduleFeedbackContext:undefined,
    });
  }

  private sendAiScheduleFeedback():void {
    const feedback = this.state.aiScheduleFeedback.trim();
    if (feedback.length === 0 || !this.props.online) {
      return;
    }

    const supportChat = this.props.chats.find((chat) => chat.chatType === ChatType.SYSTEM_CHAT);
    if (supportChat === undefined) {
      this.props.displayErrorMessage(tn.lang.scheduleAiFeedbackSupportUnavailable);
      return;
    }

    this.props.sendChatMessage({
      chatId:supportChat.id,
      msg:AI_SCHEDULE_FEEDBACK_PREFIX+"\n\n"+feedback,
    });
    this.closeAiScheduleFeedbackDialog();
  }

  private acceptSuggestion(suggestionId:number) {
    this.props.respondSuggestion({approve:true,suggestionId});
    this.toggleEditMode(0, 0);
  }

  private declineSuggestion(suggestionId:number) {
    this.props.respondSuggestion({approve:false,suggestionId, isSilent: false});
    this.toggleEditMode(0, 0);
  }

  private selectAllDaysOfWeek(startDate: number, weekMultiplier: number ) {
    if (this.props.scheduleOne === undefined) {
      return;
    }
    let endTime = Date.now();
    for (const key of Object.keys(this.props.scheduleOne.data.scheduleEntriesParentA)) {
      const scheduleEntry: IScheduleEntry = this.props.scheduleOne.data.scheduleEntriesParentA[key];
      if (scheduleEntry.endTime > endTime) {
        endTime = scheduleEntry.endTime;
      }
    }

    let spinStart = new Date(startDate);

    const newSelection: IDateRange[] = this.state.selectedEditDays.slice();

    

    while (spinStart.getTime() < endTime) {

      spinStart = addDays(spinStart, 7*weekMultiplier);

      spinStart.setHours(0);
      spinStart.setMinutes(0);
      spinStart.setSeconds(0);
      spinStart.setMilliseconds(0);

      const start = spinStart.getTime();

      spinStart.setHours(23);
      spinStart.setMinutes(59);
      spinStart.setSeconds(59);
      spinStart.setMilliseconds(999);
      const end = spinStart.getTime();

      // Check if this range overlaps with any existing entry
      const overlappingIndex = newSelection.findIndex(
        (range) => range.start <= (end+1) && range.end >= (start-1)
      );

      if (overlappingIndex !== -1) {
        // Merge with existing entry by extending its bounds
        const existing = newSelection[overlappingIndex];
        existing.start = Math.min(existing.start, start);
        existing.end = Math.max(existing.end, end);
      } else {
        // Add as a new range
        newSelection.push({ start, end });
      }

    }

    newSelection.sort((a, b) => a.start - b.start); // correct sorting in time order

    this.setState({ selectedEditDays: newSelection });
  }

  private clearSelectedDays() {
    this.setState({selectedEditDays:[]})
  }

  private selectDays(startOfStartday:number, endOfEndDay:number, days:boolean[]) {
    if (startOfStartday >= endOfEndDay) {
      return;
    } else {
      const allDaysSelected:boolean = days.every(value => value === true);
      if (days.length !== 7) {return;}
      if (allDaysSelected) {
        const newSelection:IDateRange[] = [{start:startOfStartday, end:endOfEndDay}];
        this.setState({selectedEditDays:newSelection});
      } else {
        const selection:IDateRange[] = [];

        let spinStart = new Date(startOfStartday);
        let prevDay:number = spinStart.getTime();

        let start:number|undefined ;
        while (spinStart.getTime() < endOfEndDay) {
          if (days[spinStart.getDay()]) {
            if (start === undefined) {
              start = spinStart.getTime();
            }
          } else {
            if (start !== undefined) {
              const spinEnd = new Date(prevDay);
              spinEnd.setHours(23);
              spinEnd.setMinutes(59);
              spinEnd.setSeconds(59);
              spinEnd.setMilliseconds(999);
              selection.push({start, end:spinEnd.getTime()})
              start = undefined;
            }
          }
          prevDay = spinStart.getTime();
          spinStart = addDays(spinStart, 1);
        }

        if (start !== undefined) {
          selection.push({start, end:endOfEndDay})
        }

        this.setState({selectedEditDays:selection});
      }

    }
  }

  
  private scrollToMonth(year:number, month:number, smooth?:boolean) {

    this.setCurrentMonth(year,month);
    
    if (this.state.monthSize !== "small") {
      const element = document.getElementById(year+"-"+month);
      if (element !== null) {
        if (smooth) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          element.scrollIntoView();
        }
      }  
    }
    
  }

  private swipeEditTransaction(action:"START"|"COMMIT") {
    if (this.state.editOption !== 'quickedit') {
      return;
    }

    this.setState((prev) => {
      if (action === "START") {
        return prev;
      } else {    
        if (!prev.scheduleEditPreview) {
          return prev;
        }

        let samesame:boolean = (prev.scheduleEditBase === prev.scheduleEditPreview);
        if (!samesame && prev.scheduleEditBase && prev.scheduleEditPreview) { 
          samesame = JSON.stringify(prev.scheduleEditBase) === JSON.stringify(prev.scheduleEditPreview);
        }

        let scheduleEditHistory = prev.scheduleEditHistory;
        let scheduleEditHistoryPopped = prev.scheduleEditHistoryPopped;
        if (!samesame && prev.scheduleEditBase) {
          scheduleEditHistory = this.buildHistory(prev.scheduleEditHistory,(prev.scheduleEditBase?prev.scheduleEditBase:undefined));
          scheduleEditHistoryPopped = [];
        }

        return {
          ...prev,
          scheduleEditBase:   prev.scheduleEditPreview,
          scheduleEditHistory,
          scheduleEditHistoryPopped,
        };
      }
    });
  }

  private swipeEdit(year:number,month:number,date:number, swipeDays:number, swipdeStartSide:"LEFT"|"RIGHT") {

    if (this.state.editOption !== 'quickedit') {
      return;
    }

    this.setState((prev) => {
      if (!prev.scheduleEditBase) {
        return prev;
      }
      if (swipeDays === 0) {
        return {
          ...prev,
          scheduleEditPreview: prev.scheduleEditBase,
        };
      }

      const updated = shiftSpecificDay(prev.scheduleEditBase, swipeDays, new Date(year,month,date), swipdeStartSide);

      return {
        ...prev,
        scheduleEditPreview: updated,
      };
    });
  }

  private setSelectedDay(year:number,month:number,date:number, clickAction:"SELECT"|"SELECT_FOR_EDIT"|"QUICK_EDIT", 
    position:"LEFT"|"RIGHT"|"NAN", isLongPress:boolean, originalDay?:Date) {
    
    const selectedDate:Date = new Date(year,month,date);

    if (!isLongPress && this.state.editingScheduleId === 0 && (window.innerHeight - this.monthHeight < 220) ) {

      if (this.paneRef.current) {
        const splitPane = this.paneRef.current.querySelector('#split-pane') as HTMLDivElement|null;
        if (splitPane) {
          /* Use CSS variables so the flash + base color respect the
             current theme (literals here override the JSS base style). */
          splitPane.style.backgroundColor = "var(--color-paleCoral)";
          setTimeout(() => {splitPane.style.backgroundColor = "var(--color-white)"}, 500);
      }

      if ((position === "LEFT" || position === "RIGHT") ) {
        const dayRef = document.getElementById(year + '-' + month + '-' + date) as HTMLDivElement|null;

        if (dayRef) {
          this.popMenu(dayRef);
        }
      }

    }
    setTimeout(() => {if (this.paneRef.current) {
      const splitPane = this.paneRef.current.querySelector('#split-pane') as HTMLDivElement|null;
      if (splitPane) {
        splitPane.style.backgroundColor = "var(--color-white)";
      }
    }}, 500);
    }

    if (clickAction==="SELECT_FOR_EDIT") {

      if (this.state.editOption === "quickedit" && this.state.scheduleEditBase !== undefined) {

        this.setState((prev) => {

          
          if (!prev.scheduleEditBase) {
            return prev;
          }

          const updated = swapParent(
            prev.scheduleEditBase,
            year,
            month,
            date,
            position === "LEFT" ? "MORNING" : "NIGHT",
            originalDay
          );

          return {
            ...prev,
            scheduleEditBase:   updated,
            scheduleEditPreview: updated,
            scheduleEditHistory:this.buildHistory(prev.scheduleEditHistory,(prev.scheduleEditBase?prev.scheduleEditBase:undefined)),
            scheduleEditHistoryPopped:[],
          };
        });

      } else {
        selectedDate.setHours(0);
        selectedDate.setMinutes(0);
        selectedDate.setSeconds(0);
        selectedDate.setMilliseconds(0);
  
        const start = selectedDate.getTime();
  
        selectedDate.setHours(23);
        selectedDate.setMinutes(59);
        selectedDate.setSeconds(59);
        selectedDate.setMilliseconds(999);
  
        const end = selectedDate.getTime();
  


        const newSelection:IDateRange[] = [];
        let isAdded = false;
        let mergeWithPrevCheck = false;
        let newSelect = false;
  
        for (const entry of this.state.selectedEditDays) {
          if (mergeWithPrevCheck) {
            if (newSelection[newSelection.length - 1].end === (entry.start - 1)) {
              newSelection[newSelection.length - 1].end = entry.end; // merge with previous entry
            } else {
              mergeWithPrevCheck = false;
              newSelection.push(entry);
            }
          } else if (isAdded) {
            newSelection.push(entry);
          } else if (start === entry.start ){
            if (end === entry.end) {
              isAdded = true;
              continue; // remove this entry in total
            } else {
              isAdded = true;
              newSelection.push({start:end+1,end:entry.end}); // remove at start of entry
            }
          } else if (end === entry.end ) {
            isAdded = true;
            newSelection.push({start:entry.start,end:start-1}); // remove at end of entry
          } else if ((start - 1) === entry.end) {
            isAdded = true;
            mergeWithPrevCheck = true;
            newSelection.push({start:entry.start,end}); // add at end of entry (possibly merge connecting after?)
            newSelect = true;
          } else if (end === (entry.start - 1)) {
            isAdded = true;
            newSelection.push({start,end:entry.end}); // add at start of entry
            newSelect = true;
          } else if (start > entry.start && end < entry.end) {
            isAdded = true;
            newSelection.push({start:entry.start,end:(start-1)}); // split entry to two with a 'hole' in the middle
            newSelection.push({start:end+1,end:entry.end}); 
          } else {
            newSelection.push(entry);
            newSelect = true;
          }
        }
  
        if (!isAdded) {
          newSelection.push({start,end});
          newSelect = true;
        }
  
        newSelection.sort((a,b) => a.start - b.start); // correct sorting in time order
  
        let showPromptForAllDays:number = this.state.showPromptForAllDays;
        if (newSelect && (this.state.editOption === "timePlace" || this.state.editOption === "dayvisit") 
          && this.state.showPromptForAllDays === -1) {
          showPromptForAllDays = selectedDate.getTime();
        }

        this.setState((prev) => ({...prev, selectedEditDays:newSelection, showPromptForAllDays})); 
      }
    } else {
      if (this.state.initialDayInDayPane.getDate() !== selectedDate.getDate()
        || this.state.initialDayInDayPane.getMonth() !== selectedDate.getMonth()
        || this.state.initialDayInDayPane.getFullYear() !== selectedDate.getFullYear()
        || this.state.selectedDay.getDate() !== selectedDate.getDate()
        || this.state.selectedDay.getMonth() !== selectedDate.getMonth()
        || this.state.selectedDay.getFullYear() !== selectedDate.getFullYear()) 
      {
        this.setState((prev) => ({...prev, initialDayInDayPane:selectedDate, selectedDay:selectedDate}));
        const element = document.getElementById(year+"-"+month);
        if (element !== null) {
          element.scrollIntoView();
        }
        for (const event of this.state.unseenEvents) {
          const eventDate = new Date(event.startTime);
          if (eventDate.getDate() === selectedDate.getDate()
            && eventDate.getMonth() === selectedDate.getMonth()
            && eventDate.getFullYear() === selectedDate.getFullYear()) {
              this.props.seenEvent(event.id);
          }
        }
      } else {
        this.scrollToMonth(selectedDate.getFullYear(), selectedDate.getMonth(), true);
      }
    }
  }

  private setNewEditMode(scheduleId:number, suggestionId:number, base:ISchedule, preview:ISchedule) {
    const scheduleEditBase = ensureScheduleConsistency(base);
    const scheduleEditPreview = ensureScheduleConsistency(preview);
    this.setState((prev) => ({...prev, monthSize:"large",editingScheduleId:scheduleId, editMsg:"", selectedEditDays:[], suggestionId, 
      scheduleEditPreview,scheduleEditBase, isResizing:true, scheduleEditHistory:[], scheduleEditHistoryPopped:[],
      aiSchedulePrompted:false, aiScheduleUndoFingerprint:undefined, showAiScheduleFeedbackDialog:false,
      aiScheduleFeedback:"", aiScheduleFeedbackContext:undefined}),
      () => {
        this.monthHeight = window.innerHeight-315;
        this.setCalendarHeight(this.monthHeight);   // height change that caused the jump
        requestAnimationFrame(() =>
          this.setState({ isResizing: false })      // observer re-enabled next frame
        );
      }
    
    )
  }

  private toggleEditMode(scheduleId:number, suggestionId:number) {

    if (scheduleId > 0 ) {

      const scheduleToEdit:ISchedule|undefined = this.props.allSchedules.find((schedule) => schedule.id === scheduleId);

      if (scheduleToEdit !== undefined) {
        
        let base:ISchedule;
        const suggestion = this.props.suggestions.find((sug) => sug.id === suggestionId);

        if (suggestionId === 0) {
          base = JSON.parse(JSON.stringify(scheduleToEdit));
        } else if (suggestion && suggestion.status !== SUGGESTION_TYPES.AWAITING_APPROVAL) {
          this.setState((prev) => ({...prev, errorMessage:tn.lang.calErrorSuggestionNotFound}));
          this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
          return;
        } else if (suggestion) {
          const suggestedSchedule:{schedule:ISchedule, success:boolean} = applySuggestion(scheduleToEdit, suggestion);
          if (suggestedSchedule.success) {
            base = suggestedSchedule.schedule;
          } else {
            this.setState((prev) => ({...prev, errorMessage:tn.lang.calErrorApplySuggestion, errorSuggestion:suggestion.id}));
            this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
            return;
          }
        } else {
          this.setState((prev) => ({...prev, errorMessage:tn.lang.calErrorSuggestionNotFound}));
          this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);
          return;  
        }

        this.props.history.push(`/app/calendar/${scheduleId}/${suggestionId}`);
      } else {
        alert("Could not find schedule "+scheduleId+".");
      }
    } else {

      this.props.history.push(`/app/calendar/:calendarId/:suggestionId`);

      const now = new Date();

      this.monthHeight = (this.props.appSettings && this.props.appSettings.calendarSize === "medium")
        ?((weeksMonth(now.getMonth(),now.getFullYear(),this.props.localization) * 40)+10)
        :this.props.appSettings.calendarHeight;
      const monthSize = this.props.appSettings.calendarSize;

      this.setState((prev) => ({...prev, editingScheduleId:0, monthSize, selectedEditDays:[],
        scheduleEditBase:undefined, suggestionId:0, isResizing:true, scheduleEditHistory:[], scheduleEditHistoryPopped:[],
        editMsg:"", scheduleEditPreview:undefined, highlight:[], aiSchedulePrompted:false,
        aiScheduleUndoFingerprint:undefined, showAiScheduleFeedbackDialog:false, aiScheduleFeedback:"",
        aiScheduleFeedbackContext:undefined}),
        () => {
          this.setCalendarHeight(this.monthHeight);   // height change that caused the jump
          requestAnimationFrame(() =>
            this.setState({ isResizing: false })      // observer re-enabled next frame
          );
        }
      );  
    }


  }


  private moveStart(screenY:number) {
    this.setState((prev) => ({...prev,isResizing:true}));
    this.paneStart = screenY;

    this.setCalendarHeight(this.monthHeight);
  }

  private moveMove(screenY:number) {
    const newY = screenY;
    const delta = newY - this.paneStart;
    let newMonthHeight = this.monthHeight + delta;

    if (newMonthHeight < 50) {newMonthHeight =  50;}
    if (window.innerHeight - newMonthHeight < 170) {newMonthHeight = window.innerHeight-170;}

    if (this.monthHeight !== newMonthHeight) {

      let monthSize:"small"|"medium"|"large" = "large";
      if (newMonthHeight > 100 && newMonthHeight < 300) {
        monthSize = "medium";
      } else if (newMonthHeight <= 100) {
        monthSize = "small";
      }
  
        if (this.state.monthSize !== monthSize) {
          this.setState((prev) => ({...prev,monthSize}));
        }

        this.monthHeight = newMonthHeight;
        this.paneStart = newY;
        this.setCalendarHeight(newMonthHeight);
    }
  }

  private moveEnd() {

    const bottomGap = window.innerHeight - this.monthHeight;   // how much pane is left
    if (bottomGap < 180) {
      this.setMonthSize("large");            // will set height = innerHeight-140 and hide pane
      return;                                // nothing else to do
    }

    let newMonthHeight = this.monthHeight;
    let monthSize:"small"|"medium"|"large" = "large";
    if (this.monthHeight > 100 && this.monthHeight < 300) {
      newMonthHeight = (weeksMonth(this.state.currentMonth,this.state.currentYear,this.props.localization) * 40)+10;
      monthSize = "medium";
    } else if (this.monthHeight <= 100) {
      newMonthHeight = 50;
      monthSize = "small";
    }
    this.paneStart=0;

    const currentY = this.state.currentYear;
    const currentM = this.state.currentMonth;

    this.props.updateAppSettings({calendarHeight:newMonthHeight, calendarSize:monthSize});
    this.setState((prev) => ({...prev,isResizing:true, monthSize}),
      () => {
        this.monthHeight=newMonthHeight;
        this.setCalendarHeight(newMonthHeight);
        this.scrollToMonth(currentY, currentM, false);
        requestAnimationFrame(() =>
          this.setState({ isResizing: false })      // observer re-enabled next frame
        );
      })
    
    
  }

  private setMonthSize(size:"small"|"medium"|"large") {
    let newMonthHeight = this.monthHeight;

    if (size === "large") {
      newMonthHeight = window.innerHeight-140;
    } else if (size === "medium") {
      newMonthHeight = (weeksMonth(this.state.currentMonth,this.state.currentYear,this.props.localization) * 40)+10;
    } else if (size === "small") {
      newMonthHeight = 50;
    }

    this.paneStart=0;

    const currentY = this.state.currentYear;
    const currentM = this.state.currentMonth;
    
   
    this.setState((prev) => ({...prev, isResizing:true, monthSize:size}),
      () => {
        this.monthHeight=newMonthHeight;
        this.setCalendarHeight(newMonthHeight);
        this.scrollToMonth(currentY, currentM, false);
        this.props.updateAppSettings({calendarHeight:newMonthHeight, calendarSize:size});
        requestAnimationFrame(() =>
          this.setState({ isResizing: false })      // observer re-enabled next frame
        );
      }
    );  
  }

  private setCurrentMonth(year:number, month:number) {
    if (year !== this.state.currentYear || month !== this.state.currentMonth) {

      if (this.state.monthSize === "medium") {
        this.monthHeight = (weeksMonth(month,year,this.props.localization) * 40)+10;
      }
      this.setState((prev) => ({...prev,currentMonth:month, currentYear:year}));
    }
  }

  private handleDeviceReady = () => {
    if (!this.localCalendarReady) {
      this.localCalendarReady = true;
      this.setState({ deviceReady: true });
      this.loadLocalEvents(true);
      return;
    }

    this.loadLocalEvents();
  }

  private handleLocalCalendarResume = () => {
    if (this.localCalendarReady || this.state.deviceReady) {
      this.loadLocalEvents(true);
    }
  }

  private handleLocalCalendarVisibilityChange = () => {
    if (!document.hidden) {
      this.handleLocalCalendarResume();
    }
  }

  private loadLocalEvents(force:boolean = false) {
    if (window.plugins && window.plugins.calendar) {

      if (!this.props.calendarSettings || this.props.calendarSettings.synchCalendar !== true) {
        this.setState((prev) => ({...prev,localEvents:[]}));
        return;
      }

      if (!force && Date.now() - this.lastLocalLoad <= 1000) {
        return;
      }

      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 3); // Subtract 3 months
      startDate.setHours(0, 0, 0, 0); // Reset time to the start of the day
      
      const endDate = new Date();
      endDate.setMonth(endDate.getMonth() + 9); // Add 9 months
      endDate.setHours(23, 59, 59, 999); // Set time to the end of the day
      
      const didStart = runCordovaPluginCall("Calendar.listEventsInRange", () => {
        this.lastLocalLoad = Date.now();
        window.plugins.calendar.listEventsInRange(startDate, endDate, (data: ILocalCalendarEvent[]) => {
          const newList:ILocalEvent[] = [];
          data.forEach((event: ILocalCalendarEvent) => {
            if (event.id && event.id.length > 0 && !event.id.endsWith("varannanvecka.app") && event.calendar !== undefined
              && event.startDate && event.endDate && event.title && event.title.length > 0) {

              const endTime = (new Date(event.endDate)).getTime();
              const startTime = (new Date(event.startDate)).getTime();
              newList.push({
                id:event.id,
                title:event.title,
                description:event.message,
                endTime,
                startTime,
                hasTime:true,
                calendar:event.calendar,
              });
            }
          });
          this.setState((prev) => ({...prev,localEvents:newList}));
        }, (error: any) => { console.log(error, 'error'); });
        return true;
      }, false);
      if (!didStart) {
        this.setState((prev) => ({...prev,localEvents:[]}));
      }
    }
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  let appSettings:{calendarHeight:number, calendarSize:"small"|"medium"|"large"} = state.user.appSettings;

  if (!appSettings || !appSettings.calendarHeight || !appSettings.calendarSize || appSettings.calendarHeight === 350) {
    appSettings = {calendarHeight:(window.innerHeight-140), calendarSize:"large"};
  }

  const schedules:ISchedule[] =  state.schedule.schedules;
  const calendarSettings: ICalendarSetting = state.user.calendarSettings;

  let scheduleOne:ISchedule|undefined;
  let scheduleTwo:ISchedule|undefined;
  let scheduleThree:ISchedule|undefined;

  if (calendarSettings !== undefined && calendarSettings.calendars !== undefined) {
    for (const cal of schedules) {
      if (calendarSettings.calendars.length > 0 && cal.id === calendarSettings.calendars[0]) {
        scheduleOne = cal;
      }
      else if (calendarSettings.calendars.length > 1 && cal.id === calendarSettings.calendars[1]) {
        scheduleTwo = cal;
      }
      else if (calendarSettings.calendars.length > 2 && cal.id === calendarSettings.calendars[2]) {
        scheduleThree = cal;
      }
    }
  }

  // const todos:ITodo[] = state.todo.todos?state.todo.todos:[];

  let showWeekNumber:boolean = false;
  if (state.user.showWeekNum) {
    showWeekNumber = true;
  }

  let myFamilyId = 0;
  const myFam = getSelectedFamilyResource(state.user?.session);
  if (myFam?.id !== undefined) {
      myFamilyId = myFam.id;
  }
  let externalEventsPerDay:{ [day: string]: IExternalCalenderEvent []} = NO_EXTERNAL_EVENTS;

  if (state.externalCalendar && state.externalCalendar.fetchedEventsByFamily && state.externalCalendar.fetchedEventsByFamily[""+myFamilyId]) {
    externalEventsPerDay = state.externalCalendar.fetchedEventsByFamily[""+myFamilyId];
  }

  

  const country:string|undefined = (state.user.calendarSettings && state.user.calendarSettings.holidaysCountry)
    ?state.user.calendarSettings.holidaysCountry
    :undefined;

  const localization:"en" | "se" = country
    ?(country.toLowerCase() === "us" || country.toLowerCase() === "ca")
      ?"en"
      :"se"
    :getWeekStart();

  let isTogether:boolean = false;
  if (myFam !== undefined) {
      isTogether = myFam.familyType === "TOGETHER";
  }

  return {
    userId,
    localization,
    appSettings,
    scheduleOne,
    scheduleTwo,
    scheduleThree,
    // todos,
    calendarSettings,
    allSchedules:schedules,
    family:state.family.family,
    suggestions:state.suggestion.suggestions?state.suggestion.suggestions:[],
    events:state.event.events?state.event.events:[],
    showWeekNumber,
    chats:state.chat.chats?state.chat.chats:[],
    online:state.connection.loadCompleted,
    externalEventsPerDay,
    isTogether,
  };
}

const mapDispatchToProps = {
  updateAppSettings: UserActions.appSettings,
  createSuggestion: Suggestion.createSuggestion,
  respondSuggestion: Suggestion.respondSuggestion,
  createChat: ChatActions.createChat,
  sendChatMessage: ChatActions.createChatMessage,
  displayErrorMessage: UserActions.displayErrorMessage,
  seenEvent: EventActions.seenEvent,
  updateToken: UserActions.updateAppToken,
  storeToken: UserActions.storeAppToken,
};

interface IExtractedIds {
  scheduleId: number | null;
  suggestionId: number | null;
  eventId:number | null;
}


function extractIdsFromString(params: any): IExtractedIds {
  
  const { calendarId, suggestionId } = params as IRouteParams;

  if (calendarId && suggestionId) {

    if (calendarId !== undefined && calendarId === "event") {
      const eventnIdParsed = parseInt(suggestionId,10);
      if (isNumber(eventnIdParsed)) {
        return {
          scheduleId: null,
          suggestionId: null,
          eventId:eventnIdParsed,
        };
      }
    } else {
      const scheduleIdParsed = parseInt(calendarId,10);
      const suggestionIdParsed = parseInt(suggestionId,10);
  
      if (isNumber(scheduleIdParsed) && isNumber(suggestionIdParsed)) {
        return {
          scheduleId: scheduleIdParsed,
          suggestionId: suggestionIdParsed,
          eventId:null,
        };
      }

    }
  }
  return {
    scheduleId: null,
    suggestionId: null,
    eventId:null,
  };
}

function isNumber(n:number) {
  return !isNaN(n) && isFinite(n);
}



export default connect(mapStateToProps, mapDispatchToProps)(withStyles(calendarStyle)(withRouter(CalendarContainer)));



// WEBPACK FOOTER //
// ./src/containers/calendar/calendar.container.tsx